import styled from 'styled-components';

export const Container = styled.div`
  background-color: #f3f4f6;
  display: grid;
  place-items: center;
  height: 100vh;

  & .content {
    background-color: white;
    min-width: 40%;
    border-radius: 12px;
  }
`;
